/**
 * 地块测绘库内坐标为 BD09；天地图为 CGCS2000（与 WGS84 可互换）。
 * 仅在地图显示/点击边界转换，不改库存数据。
 */

const PI = Math.PI;
const X_PI = (PI * 3000.0) / 180.0;
const A = 6378245.0;
const EE = 0.00669342162296594323;

function outOfChina(lng, lat) {
  return lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271;
}

function transformLat(lng, lat) {
  let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
  ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
  ret += ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) * 2.0) / 3.0;
  ret += ((160.0 * Math.sin((lat / 12.0) * PI) + 320.0 * Math.sin((lat * PI) / 30.0)) * 2.0) / 3.0;
  return ret;
}

function transformLng(lng, lat) {
  let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
  ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
  ret += ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) * 2.0) / 3.0;
  ret += ((150.0 * Math.sin((lng / 12.0) * PI) + 300.0 * Math.sin((lng / 30.0) * PI)) * 2.0) / 3.0;
  return ret;
}

export function bd09ToGcj02(lng, lat) {
  const x = Number(lng) - 0.0065;
  const y = Number(lat) - 0.006;
  if (!Number.isFinite(x) || !Number.isFinite(y)) {
    return { lng: Number(lng), lat: Number(lat) };
  }
  const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
  const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
  return { lng: z * Math.cos(theta), lat: z * Math.sin(theta) };
}

export function gcj02ToBd09(lng, lat) {
  const lngN = Number(lng);
  const latN = Number(lat);
  if (!Number.isFinite(lngN) || !Number.isFinite(latN)) {
    return { lng: lngN, lat: latN };
  }
  const z = Math.sqrt(lngN * lngN + latN * latN) + 0.00002 * Math.sin(latN * X_PI);
  const theta = Math.atan2(latN, lngN) + 0.000003 * Math.cos(lngN * X_PI);
  return { lng: z * Math.cos(theta) + 0.0065, lat: z * Math.sin(theta) + 0.006 };
}

export function wgs84ToGcj02(lng, lat) {
  const lngN = Number(lng);
  const latN = Number(lat);
  if (!Number.isFinite(lngN) || !Number.isFinite(latN) || outOfChina(lngN, latN)) {
    return { lng: lngN, lat: latN };
  }
  let dLat = transformLat(lngN - 105.0, latN - 35.0);
  let dLng = transformLng(lngN - 105.0, latN - 35.0);
  const radLat = (latN / 180.0) * PI;
  let magic = Math.sin(radLat);
  magic = 1 - EE * magic * magic;
  const sqrtMagic = Math.sqrt(magic);
  dLat = (dLat * 180.0) / (((A * (1 - EE)) / (magic * sqrtMagic)) * PI);
  dLng = (dLng * 180.0) / ((A / sqrtMagic) * Math.cos(radLat) * PI);
  return { lng: lngN + dLng, lat: latN + dLat };
}

export function gcj02ToWgs84(lng, lat) {
  const g = wgs84ToGcj02(lng, lat);
  return { lng: Number(lng) * 2 - g.lng, lat: Number(lat) * 2 - g.lat };
}

export function bd09ToWgs84(lng, lat) {
  const g = bd09ToGcj02(lng, lat);
  return gcj02ToWgs84(g.lng, g.lat);
}

export function wgs84ToBd09(lng, lat) {
  const g = wgs84ToGcj02(lng, lat);
  return gcj02ToBd09(g.lng, g.lat);
}
